// 부모 컴포넌트에서 사용
import { useSetAuth } from '../../../utils/useSetAuth';
import FormListWithEditor from '../../../components/FormListWithEditor';
import { useEffect, useState } from 'react';
import { useGetVisitOath } from '../../../hooks/useTablet';
import { apiPost } from '../../../services/_common';
import { userState } from '../../../atoms';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const SafeEduListForm = () => {
  const { auth } = useSetAuth();
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const { data: originData, isLoading, isError, refetch } = useGetVisitOath();
  const [visitOathList, setVisitOathList] = useState<any[]>([]);

  useEffect(() => {
    // 데이터 받으면 setVisitOathList에 업데이트
    if (originData) {
      setVisitOathList(originData);
    }
  }, [originData]);

  const handleSave = async (formData: any) => {
    const res = await apiPost({ path: '/visit/oath', req: { ...formData, hCd: userInfo.hCd, sCd: userInfo.sCd }, contentType: 'application/json' });
    if (res.data.statusCode === 200) {
      toast.success(t('저장되었습니다.'));
      setVisitOathList(res.data.data);
    }
  };

  const handleUseYnChange = async (item: any, showAlert: boolean = true) => {
    const req = { id: item.id, useYn: item.useYn === 'Y' ? 'N' : 'Y', hCd: userInfo.hCd, sCd: userInfo.sCd };
    const res = await apiPost({ path: '/visit/oath/useyn', contentType: 'application/json', req });
    if (res.data.statusCode === 200) {
      if (showAlert) toast.success(t('저장되었습니다.'));
      setVisitOathList(res.data.data);
    }
  };

  return (
    <FormListWithEditor
      data={visitOathList || []}
      originData={visitOathList}
      isLoading={isLoading}
      isError={isError}
      auth={auth}
      refetch={refetch}
      menuName='방문자 서약서'
      onSave={handleSave}
      onUseYnChange={handleUseYnChange}
    />
  );
};

export default SafeEduListForm;
